<script setup lang="ts">
import { computed } from 'vue'
import type { BuildStatus } from '@/types/business'
const props = defineProps<{ status: BuildStatus }>()
const map = { completed:{label:'已完成',type:'success'}, demo:{label:'演示中',type:'warning'}, planned:{label:'规划中',type:'info'} } as const
const current = computed(() => map[props.status])
</script>
<template><el-tag :type="current.type" size="small" effect="light">{{ current.label }}</el-tag></template>
